<template>
  <div>
    <EvaluationDetail id="EvaluationDetail" v-on:backFromDetail="backFromDetail" :evaluations="this.filteredEvaluations" :evaluationName="evaluationName"
            v-show="detailView"></EvaluationDetail>
    <RunDetail v-on:backFromDetail="backFromDetail" :runId="this.runId" :evaluations="this.aggregatedRuns" v-show="runDetailView" >
    </RunDetail>
    <h5>{{title}}</h5>
    <div class="table-responsive">
      <table class="table">
        <thead >
          <tr>
            <th scope="col">Name</th>
            <th scope="col">Win%</th>
            <th scope="col">Run</th>
            <th scope="col">Dataset</th>
          </tr>
        </thead>
        <tbody >
          <tr v-for="evaluation in evaluations" v-bind:key='evaluation._id' >
            <td id="nameCell" class="clickable" v-on:click="showEvaluationDetail(evaluation)">{{evaluation.displayName}} </td>
            <td>{{evaluation.winPercentage}}</td>
            <td v-on:click="showRunDetail(evaluation)" class="clickable">{{evaluation.dataset.runDate}}</td>
            <td>{{evaluation.dataset.number}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import EvaluationDetail from './EvaluationDetail.vue'
import RunDetail from './RunDetail.vue'
export default {
  name: 'EvaluationList',
  props: {
    status: String
  },
  components: {
    EvaluationDetail,
    RunDetail
  },
  data () {
    return {
      title: 'Evaluations',
      evaluations : [],
      detailView: false,
      runDetailView: false,
      evaluationName: "",
      filteredEvaluations: [],
      aggregatedRuns: [],
      runId: ""
    }
  },
  methods: {
    showEvaluationDetail: function (evaluation) {
      this.evaluationName = evaluation.name
      this.filteredEvaluations = this.evaluations.filter(evaluation => evaluation.name === this.evaluationName)
      this.detailView = true
      this.runDetailView = false
    },
    backFromDetail() {
      this.detailView = false
      this.runDetailView = false
    },
    showRunDetail: function (evaluation) {
      var runId = evaluation.run
      this.runId = runId + ""
      this.filteredEvaluations = this.evaluations.filter(evaluation => evaluation.run === runId)
      this.aggregatedRuns = aggregateRuns(this.filteredEvaluations)
      this.runDetailView = true
    }
  },
  mounted () {
    axios
      .get(process.env.VUE_APP_BASE_URL + '/v2/evaluations')
      .then(response => {
        var count = 0
        var currentVersion = ""
        for (var i = 0; i < response.data.length; i++) {
          response.data[i].winPercentage = (100 * response.data[i].winPercentage).toFixed(3)
          //Set percentile
          if (response.data[i].dataset.number !== currentVersion) {
            currentVersion = response.data[i].dataset.number
            count = 0
          }
          count++
          response.data[i].percentile = (1  - (count / response.data.filter(record => record.dataset.number === currentVersion).length)
            + (1 / response.data.filter(record => record.dataset.number === currentVersion).length)).toFixed(2)
          response.data[i].displayName = response.data[i].name || "unknown"
          if(response.data[i].name && response.data[i].name.length > 42) response.data[i].displayName = response.data[i].name.substr(0,40) + '...'
        }
          this.evaluations = response.data
      })
  }
}

function aggregateRuns (evaluations) {
  var evaluationsObj = {}
  for (var i = 0; i  < evaluations.length; i++) {
    var evaluation = evaluations[i]
    if (!evaluationsObj[evaluation.name]) evaluationsObj[evaluation.name] = {count:0, totalPercent:0}
    evaluationsObj[evaluation.name].count ++
    evaluationsObj[evaluation.name].totalPercent += 1 * evaluation.winPercentage
  }
  var aggregatedRuns = []
  Object.keys(evaluationsObj).forEach(name => {
    aggregatedRuns.push({name: name, averagePercentage: (evaluationsObj[name].totalPercent / evaluationsObj[name].count).toFixed(2)})
  })
  aggregatedRuns.sort((a, b) => (a.averagePercentage > b.averagePercentage) ? -1 : 1)
  return aggregatedRuns
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#nameCell {
  font-size: 10pt
}

#EvaluationDetail {
  align-items: center;
}
</style>
